/**
 * Product Guidance visual identity.
 *
 * Ace uses a compass because the assistant's primary job is orientation:
 * explain where the user is, how to complete a task, and what to do next.
 * Keep this intentionally simple and avoid generic "AI sparkle" branding.
 */
export const ACE_ICON_CLASS = 'bi bi-compass';
